import {
  Slot
} from "../../../chunk-5DWHOSR4.mjs";
import {
  Arrow2,
  Content2,
  Portal,
  Provider,
  Root3,
  Trigger
} from "../../../chunk-JDOTBHDX.mjs";
import "../../../chunk-UFV3XC2K.mjs";
import "../../../chunk-VQI4KMJ3.mjs";
import "../../../chunk-MTQX4T3Q.mjs";
import "../../../chunk-XFG5THGD.mjs";
import "../../../chunk-RRWBFD4V.mjs";
import "../../../chunk-HFXIPTW6.mjs";
import "../../../chunk-OPCIACWD.mjs";
import "../../../chunk-GYRZVAMU.mjs";
import "../../../chunk-QOCR4XUU.mjs";
import "../../../chunk-D6QHF2UO.mjs";
import "../../../chunk-7TMHQ6XO.mjs";
import "../../../chunk-BQ72SK4G.mjs";
import "../../../chunk-FBWCVJGC.mjs";
import "../../../chunk-CD4FQC4X.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Tooltip/Tooltip.tsx
import { cloneElement, Fragment, isValidElement, useCallback, useEffect, useLayoutEffect, useState } from "react";
import { MdInfoOutline } from "react-icons/md";
import { useShadowPortalContainer } from "../../../hooks/useShadowPortalContainer.mjs";
import { keyboardFocusOnly, useTooltipPointer, useTooltipShown } from "./tooltipTrigger.mjs";
import { Fragment as Fragment2, jsx, jsxs } from "react/jsx-runtime";
function hasOwnName(child) {
  return Boolean(child.props["aria-label"] || child.props["aria-labelledby"]);
}
var NAMEABLE = 'button, a[href], [role]:not([role="none"]):not([role="presentation"]):not([role="generic"])';
function rendersNoName(node) {
  return node.matches(NAMEABLE) && !node.textContent?.trim();
}
function attaches(children) {
  return isValidElement(children) && children.type !== Fragment && !("disabled" in children.props);
}
function describe(children, describedBy) {
  if (!describedBy || !isValidElement(children) || children.type === Fragment) return children;
  return cloneElement(children, { "aria-describedby": [children.props["aria-describedby"], describedBy].filter(Boolean).join(" ") });
}
function TooltipAttach({ children, ...props }) {
  return /* @__PURE__ */ jsx(Slot, { ...props, children: describe(children, props["aria-describedby"]) });
}
function TooltipWrap({ children, ...props }) {
  return /* @__PURE__ */ jsx("span", { ...props, className: "buyscout-tooltip-wrap", children: describe(children, props["aria-describedby"]) });
}
function Tooltip({ title, description, children, placement = "top", disabled = false, describes = true, instant = false }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (disabled) setOpen(false);
  }, [disabled]);
  const [container, handleTriggerRef] = useShadowPortalContainer();
  const [trigger, setTrigger] = useState(null);
  const attachTrigger = useCallback((node) => {
    handleTriggerRef(node);
    setTrigger(node);
  }, [handleTriggerRef]);
  const [nameless, setNameless] = useState(false);
  const closeOnPress = useTooltipPointer(trigger, setOpen, disabled, instant);
  const { swap, popupRef } = useTooltipShown(open && !disabled, instant);
  const attached = attaches(children);
  const ownName = attached && hasOwnName(children);
  useLayoutEffect(() => {
    setNameless(Boolean(trigger) && !ownName && rendersNoName(trigger));
  });
  if (!title) return children;
  const silent = !describes && { "aria-describedby": void 0 };
  return /* @__PURE__ */ jsx(Provider, { delayDuration: 0, children: /* @__PURE__ */ jsxs(Root3, { open: open && !disabled, onOpenChange: (next) => setOpen(next && !disabled), children: [
    attached ? /* @__PURE__ */ jsx(Trigger, { asChild: true, onFocus: keyboardFocusOnly, onPointerDown: closeOnPress, ref: attachTrigger, "aria-label": nameless ? title : void 0, ...silent, children: /* @__PURE__ */ jsx(TooltipAttach, { children }) }) : /* @__PURE__ */ jsx(Trigger, { asChild: true, onFocus: keyboardFocusOnly, onPointerDown: closeOnPress, ...silent, children: /* @__PURE__ */ jsx(TooltipWrap, { ref: attachTrigger, children }) }),
    /* @__PURE__ */ jsx(Portal, { container, children: /* @__PURE__ */ jsxs(
      Content2,
      {
        ref: popupRef,
        "data-swap": swap || void 0,
        side: placement,
        sideOffset: 6,
        collisionPadding: 8,
        className: description ? "buyscout-tooltip-popup buyscout-tooltip-popup--rich" : "buyscout-tooltip-popup",
        children: [
          description ? /* @__PURE__ */ jsxs(Fragment2, { children: [
            /* @__PURE__ */ jsx("span", { className: "buyscout-tooltip-popup__title", children: title }),
            /* @__PURE__ */ jsx("span", { className: "buyscout-tooltip-popup__body", children: description })
          ] }) : title,
          /* @__PURE__ */ jsx(Arrow2, { className: "buyscout-tooltip-popup__arrow", width: 8, height: 4 })
        ]
      }
    ) })
  ] }) });
}
function InfoTip({ className, ...tooltip }) {
  return /* @__PURE__ */ jsx(Tooltip, { ...tooltip, children: /* @__PURE__ */ jsx("button", { type: "button", className: ["buyscout-infotip", className].filter(Boolean).join(" "), children: /* @__PURE__ */ jsx(MdInfoOutline, { "aria-hidden": true }) }) });
}
InfoTip.displayName = "InfoTip";
Tooltip.displayName = "Tooltip";
export {
  InfoTip,
  Tooltip
};
//# sourceMappingURL=Tooltip.mjs.map